export enum RECOURS_TYPE {
	None = 0,
	MinimalDuration = 1,
	PreciseTerm = 2,
	Formation = 3,
	CDI = 4,
	Apprentissage = 5,
	Professionnalisation = 6,
}
